import { useEffect, useState } from "react";
import { statusMeta, stickyAddress } from "@/mocks/home";

export default function Hero() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 1800);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const copyForever = async () => {
    try {
      await navigator.clipboard.writeText(stickyAddress.host);
    } catch {
      // ignore clipboard failures
    }
    setCopied(true);
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto max-w-shell px-4 pb-16 pt-12 md:px-6 md:pb-24 md:pt-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="reveal lg:col-span-7">
            <div className="flex flex-wrap items-center gap-3">
              <span className="rounded-full bg-foreground-950 px-3 py-1 font-label text-[11px] tracking-[0.3em] text-background-100">
                {statusMeta.issue}
              </span>
              <span className="font-label text-xs tracking-[0.2em] text-foreground-500">
                2026.09.11 · 第 4 期发布
              </span>
            </div>

            <h1 className="mt-7 font-heading text-[44px] font-black leading-[1.05] tracking-tight text-foreground-950 md:text-[68px] lg:text-[76px]">
              黑料总站
            </h1>

            <div className="mt-6 h-px w-full max-w-md bg-foreground-950/15" />

            <p className="mt-6 max-w-2xl text-sm leading-8 text-foreground-700 md:text-base md:leading-9">
              这里是<strong className="font-semibold text-foreground-950">黑料总站发布页</strong>，
              把黑料总站备用、黑料总站镜像、黑料总站新地址与黑料总站永久地址整理在同一页。
              主站无法访问时，可直接在本页切换备用入口；收藏本页，即可随时找回最新通道，
              真正做到黑料总站防走丢。
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#channels"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-door-open-line text-lg" />
                查看全部入口通道
              </a>
              <button
                type="button"
                onClick={copyForever}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 px-6 py-3.5 font-label text-sm text-foreground-900 transition-colors hover:border-primary-500 hover:text-primary-600"
              >
                <i className={copied ? "ri-check-line text-lg" : "ri-file-copy-line text-lg"} />
                {copied ? "永久地址已复制" : `复制永久地址`}
              </button>
            </div>

            <dl className="mt-11 grid max-w-2xl grid-cols-2 gap-6 border-t border-background-300 pt-7 sm:grid-cols-3">
              <div>
                <dt className="font-label text-[11px] tracking-[0.2em] text-foreground-500">
                  当前通道
                </dt>
                <dd className="mt-2 font-heading text-base font-semibold text-foreground-950">
                  {statusMeta.activeChannel}
                </dd>
              </div>
              <div>
                <dt className="font-label text-[11px] tracking-[0.2em] text-foreground-500">
                  在线线路
                </dt>
                <dd className="mt-2 font-heading text-base font-semibold text-foreground-950">
                  {statusMeta.totalChannels}
                </dd>
              </div>
              <div className="col-span-2 sm:col-span-1">
                <dt className="font-label text-[11px] tracking-[0.2em] text-foreground-500">
                  最近更新
                </dt>
                <dd className="mt-2 font-heading text-base font-semibold text-foreground-950">
                  {statusMeta.updatedAt}
                </dd>
              </div>
            </dl>
          </div>

          <div className="reveal lg:col-span-5">
            <figure className="relative mx-auto w-full max-w-[420px]">
              <div className="absolute -left-4 -top-4 hidden h-24 w-24 border-l-2 border-t-2 border-primary-500/60 lg:block" />
              <div className="overflow-hidden rounded-lg border border-background-300 bg-background-100">
                <div className="relative h-[420px] w-full md:h-[520px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20magazine%20cover%20background%2C%20crumpled%20cream%20paper%20texture%20with%20bold%20crimson%20red%20abstract%20brush%20strokes%20and%20gold%20foil%20accents%2C%20dramatic%20side%20lighting%2C%20high%20fashion%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20subtle%20film%20grain%2C%20large%20negative%20space%2C%20sophisticated%20print%20design%20aesthetic&width=1200&height=1500&seq=cover-01&orientation=portrait"
                    alt="黑料总站发布页封面视觉"
                    title="黑料总站发布页封面"
                    className="h-full w-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
                  <figcaption className="absolute inset-x-0 bottom-0 p-6">
                    <span className="font-label text-[10px] tracking-[0.34em] text-accent-300">
                      COVER STORY
                    </span>
                    <p className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50">
                      一页收齐
                      <br />
                      所有备用入口
                    </p>
                    <p className="mt-3 font-label text-xs text-background-200/80">
                      主站 · 备用 · 镜像 · 永久地址
                    </p>
                  </figcaption>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-background-300 pt-3">
                <span className="font-label text-[11px] tracking-[0.22em] text-foreground-500">
                  {statusMeta.issue} · PUBLISHING PAGE
                </span>
                <span className="font-label text-[11px] text-foreground-500">
                  {stickyAddress.host}
                </span>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}